import React from 'react';
import { Drawer, Toolbar, Typography, Divider, List, ListItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import CampaignIcon from '@mui/icons-material/Campaign';

const drawerWidth = 220;

export default function Sidebar({ open, onClose, navItems, selectedPath }) {
  if (!open) return null;
  return (
    <Box component="nav" sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }} aria-label="sidebar navigation">
      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={open}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        <SidebarContent navItems={navItems} selectedPath={selectedPath} />
      </Drawer>
      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
        open
      >
        <SidebarContent navItems={navItems} selectedPath={selectedPath} />
      </Drawer>
    </Box>
  );
}

function SidebarContent({ navItems, selectedPath }) {
  // Only show Customer Campaigns for business users
  const role = typeof window !== 'undefined' ? localStorage.getItem('role') : null;
  // Insert Customer Campaigns after Credit Reminders and before Profile, only for business
  const updatedNavItems = [];
  let inserted = false;
  navItems.forEach((item) => {
    updatedNavItems.push(item);
    if ((item.text === 'Credit Reminders' || item.text === 'Business Credits') && role === 'business') {
      updatedNavItems.push({
        text: 'Customer Campaigns',
        path: '/business/customer-campaigns',
        icon: <CampaignIcon />,
      });
      inserted = true;
    }
  });
  // If not inserted (e.g., Credit Reminders not found), add before Profile (only for business)
  if (!inserted && role === 'business') {
    const profileIdx = updatedNavItems.findIndex(i => i.text === 'Profile');
    updatedNavItems.splice(profileIdx, 0, {
      text: 'Customer Campaigns',
      path: '/business/customer-campaigns',
      icon: <CampaignIcon />,
    });
  }
  return (
    <>
      <Toolbar sx={{ minHeight: 64 }}>
        <Typography variant="h6" fontWeight={700} color="text.primary">
          ShopZo
        </Typography>
      </Toolbar>
      <Divider />
      <List>
        {updatedNavItems.map((item) => (
          <ListItem
            button
            key={item.text}
            component={Link}
            to={item.path}
            selected={selectedPath === item.path}
            sx={{
              borderRadius: 2,
              mb: 0.5,
              bgcolor: selectedPath === item.path ? 'action.selected' : 'inherit',
              '&:hover': { bgcolor: 'action.hover' },
            }}
          >
            <ListItemIcon sx={{ color: 'text.secondary' }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} primaryTypographyProps={{ fontWeight: 600 }} />
          </ListItem>
        ))}
      </List>
    </>
  );
} 
